import React, { useEffect } from "react";
import "../../styles/KeyboardShortcut.css";

const shortcutsData = [
  { shortcut: "1, 2, 3, 4, 5, 6", action: "Window level", section: 1 },
  { shortcut: "m", action: "Select image panning tool", section: 1 },
  { shortcut: "z", action: "Select image zooming tool", section: 1 },
  { shortcut: "l", action: "Select length tool", section: 1 },
  { shortcut: "e", action: "Select ellipse tool (HU)", section: 1 },
  { shortcut: "a", action: "Select angle tool", section: 1 },
  { shortcut: "y", action: "Select ArrowAnnotate tool", section: 1 },
  { shortcut: "Home", action: "Go to first series", section: 1 },
  
  // Second section - Navigation
  { shortcut: "End", action: "Go to last series", section: 2 },
  { shortcut: "←", action: "Go to previous series", section: 2 },
  { shortcut: "→", action: "Go to next series", section: 2 },
  { shortcut: "↑", action: "Go to previous frame", section: 2 },
  { shortcut: "↓", action: "Go to next frame", section: 2 }
];

export default function KeyboardShortcut({ onClose }) {
  // Handle escape key press to close
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    
    // Prevent body scroll when modal is open
    document.body.style.overflow = "hidden";
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = "auto";
    };
  }, [onClose]);

  // Handle click outside to close
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const firstSectionShortcuts = shortcutsData.filter(s => s.section === 1);
  const secondSectionShortcuts = shortcutsData.filter(s => s.section === 2);

  return (
    <div className="keyboard-shortcut-overlay" onClick={handleOverlayClick}>
      <div className="keyboard-shortcut-modal">
        {/* Close button top right */}
        <button 
          className="keyboard-shortcut-close-btn"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>

        {/* Scrollable Content Area */}
        <div className="keyboard-shortcut-content">
          <h1 className="keyboard-shortcut-title">Keyboard Shortcuts</h1>

          {/* First Table */}
          <div className="keyboard-shortcut-table">
            <div className="keyboard-shortcut-table-header">
              <div className="keyboard-shortcut-col-shortcut">Shortcut</div>
              <div className="keyboard-shortcut-col-action">Action</div>
            </div>
            {firstSectionShortcuts.map((item, index) => (
              <div key={index} className="keyboard-shortcut-table-row">
                <div className="keyboard-shortcut-col-shortcut">
                  <kbd className="keyboard-shortcut-kbd">{item.shortcut}</kbd>
                </div>
                <div className="keyboard-shortcut-col-action">{item.action}</div>
              </div>
            ))}
          </div>

          {/* Second Table */}
          <div className="keyboard-shortcut-table">
            
            {secondSectionShortcuts.map((item, index) => (
              <div key={index} className="keyboard-shortcut-table-row">
                <div className="keyboard-shortcut-col-shortcut">
                  <kbd className="keyboard-shortcut-kbd">{item.shortcut}</kbd>
                </div>
                <div className="keyboard-shortcut-col-action">{item.action}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Fixed Bottom Close Button */}
        <div className="keyboard-shortcut-bottom-close">
          <button 
            className="keyboard-shortcut-bottom-close-btn"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  );
}